/* eslint-disable no-param-reassign */
import { useEffect, useRef } from 'react';
import { focusWithoutScrolling } from '@react-aria/utils';
/**
 * Toggles focus between the source element, and its target.
 * (I.e., between a button and a modal depending upon if the modal
 * is showing).
 */

export function useToggleFocus(targetRef) {
  var isShowing = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var sourceRef = useRef(null);
  var wasShowingRef = useRef(null);
  useEffect(function () {
    if (isShowing) {
      wasShowingRef.current = true;
      sourceRef.current = document.activeElement;

      if (targetRef.current && targetRef.current.focus) {
        focusWithoutScrolling(targetRef.current);
      }
    }

    return function () {
      if (wasShowingRef.current && sourceRef.current && sourceRef.current.focus) {
        setTimeout(function () {
          focusWithoutScrolling(sourceRef.current);
        }, 0);
        wasShowingRef.current = false;
      }
    };
  }, [isShowing, targetRef]);
}